import service from "@/store/services/establishment-transfer-items-service";

export const state = () => ({
  list: {},
  item: {},
  meta: {},
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, item) => {
    state.item = item;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

export const actions = {
  list({ commit }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },
  get({ commit }, id) {
    return service.get(id).then((item) => {
      commit("SET_RESOURCE", item);
    });
  },
  add({ commit }, item) {
    return service.add(item).then((created) => {
      commit("SET_RESOURCE", created);
    });
  },
  update({ commit }, item) {
    return service.update(item).then((updated) => {
      commit("SET_RESOURCE", updated);
    });
  },
  destroy(_ctx, id) {
    return service.destroy(id);
  },
};

export const getters = {
  list: (state) => state.list,
  item: (state) => state.item,
  meta: (state) => state.meta,
};

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default module;
